/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=21e77986&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/prod-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__